import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PostRefreshService {

  private readonly refreshSubject = new Subject<void>();

  refresh$ = this.refreshSubject.asObservable();

  refreshPosts() {
    this.refreshSubject.next();
  }
}
